import { create } from 'zustand';

interface MapState {
	position: google.maps.LatLngLiteral | null;
	address: string;
	setPosition: (position: google.maps.LatLngLiteral) => void;
	setAddress: (address: string) => void;
}

export const useMapsStore = create<MapState>((set) => ({
	position: null,
	address: '',
	setPosition: (position) => set({ position }),
	setAddress: (address) => set({ address }),
}));
